import { FC } from 'react';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';
import AdvertListFilterContentCss from '#srcCssModules/advert/list-filter/advert-list-filter-content.module.scss';
import { Close } from '#advertList/components/filter/detail/Close';
import { FilterItemDetailList } from '#advertList/components/filter/detail/FilterItemDetailList';

const Detail: FC = () => {
  const { isVisible } = useFilterContext();

  if (!isVisible) {
    return null;
  }

  return (
    <div className={AdvertListFilterContentCss.advertListFilterContent}>
      <FilterItemDetailList />
      <Close />
    </div>
  );
};

export { Detail };
